import React, { useState, useEffect } from 'react';
import Template from '../../../components/organisms/Template';
import { Row, Col, Form, Button } from 'react-bootstrap';
import InputText from '../../../components/atoms/InputText';
import InputTextArea from '../../../components/atoms/InputTextArea';
import useForm from '../../../helpers/formHelper';
import ButtonSubmit from '../../../components/atoms/ButtonSubmit';
import { useAlert } from 'react-alert';
import PageHeader from '../../../components/molecules/PageHeader';
import { getIdFromUrlLocationPathname, formatMoney, formatDateWithYear } from '../../../helpers/functions';
import { getTask } from '../../../services/Tasks';

function ReceiptGenerate(props) {

  const [loading, setLoading] = useState(false);

  const [validated, setValidated] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const id = getIdFromUrlLocationPathname(props.history.location.pathname);
  const alert = useAlert();

  const backpage = async () => {
    props.history.push(`/task/detail/${inputs.id}`);
  };

  const getInputsFromURL = (pathname) => {
    if (pathname) {
      return pathname.substring(pathname.lastIndexOf('receipt/generate/') + 17);
    }

    return '';
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      let inputs = {};
      const encodedInputs = getInputsFromURL(props.history.location.pathname);
      
      if (encodedInputs.indexOf('{') >= 0) {
        inputs = JSON.parse(encodedInputs);
      } else {
        const result = await getTask(id, alert);

        if (result) {
          inputs = {
            id: id,
            nome: result.nome,
            valor: formatMoney(),
            data: formatDateWithYear(result.dataHoraInicio),
            servico: 'Produção completa da noiva, prova de maquiagem, assessoria na escolha dos acessórios, deslocamento ao local do evento e acompanhamento N1 após a cerimônia.'
          };
        }
      }

      setInputs(inputs);
      setLoading(false);
    };

    fetchData();
  }, [id]);

  const register = async () => {
    setLoading(true);
    props.history.push(`/receipt/export/${encodeURI(JSON.stringify(inputs))}`);
    setLoading(false);
  };

  const { inputs, handleInputChange, setInputs, validateInputs } = useForm();

  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const errors = validateInputs({ page: 'generate' });
      if (errors && errors.length > 0) {
        event.stopPropagation();
        setValidationErrors(errors);
      } else {
        register();
      }
    }

    setValidated(true);
  };

  return (
    <Template validationErrors={validationErrors} clearErrosFunc={() => setValidationErrors([])}
      loading={loading}>
      <PageHeader tittle="Gerar recibo" />
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row>
          <Col>
            <InputText id="nome" name="Nome" value={inputs.nome || ''}
              onChange={handleInputChange} required />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputText id="cpf" name="CPF" value={inputs.cpf || ''}
              onChange={handleInputChange} required />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputText id="data" name="Data Evento" value={inputs.data || ''}
              onChange={handleInputChange} required />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputText id="valor" name="Valor Recebido" value={inputs.valor || ''}
              onChange={handleInputChange} required />
          </Col>
          <Col>
            <InputText id="valorextenso" name="V. R. Extenso" value={inputs.valorextenso || ''}
              onChange={handleInputChange} required />
          </Col>
        </Row>
        <Row>
          <Col>
          <InputText id="referencia" name="Referente à" value={inputs.referencia || ''}
              onChange={handleInputChange} required />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextArea id="servico" name="Serviço" value={inputs.servico || ''}
              onChange={handleInputChange} required />
          </Col>
        </Row>
        <Button variant="secondary" size="lg" className="float-left" onClick={() => backpage()}>Voltar</Button>
        <ButtonSubmit variant="success" type="submit">Gerar recibo</ButtonSubmit>
      </Form>
    </Template >
  );
}

export default ReceiptGenerate;